import WidgetDropdownMultiple from 'components/Widgets/WidgetDropdownMultiple';

const SelectCheckTypeField = ({ item, selectItem, setNewSelectItem, disabled }) => {
  return (
    <WidgetDropdownMultiple
      arrayItems={item?.setting.reduce((acc, itemV) => {
        if (selectItem?.value?.split(',')) {
          selectItem?.value?.split(',')?.map((si) => {
            if (si == itemV.param) {
              itemV['selected'] = true;
            }
          });
        }
        if (itemV.param !== 'multiply') {
          acc.push(itemV);
        }
        return acc;
      }, [])}
      selected={selectItem?.value}
      selectedItems={selectItem?.setting?.items?.split(',').map((val) => {
        return val.trim();
      })}
      multiply={
        item?.setting ? item.setting.find((item) => item.param === 'multiply')?.value : false
      }
      itemKey={'param'}
      itemValue={'value'}
      setOutput={(val) =>
        setNewSelectItem({
          value: val.value ?? ' ',
          setting: {
            items: val.items,
          },
        })
      }
      disabled={disabled}
    />
  );
};

export default SelectCheckTypeField;
